module.exports = __webpack_public_path__ + "img/2.9cec8240.png";